import { ArrowUpRight, Heart, Rocket } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function No404Promo() {
  return (
    <section
      className="relative py-20 md:py-28"
      data-testid="no404-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <a
            href="https://no404.fun"
            target="_blank"
            rel="noopener noreferrer"
            className="block group"
            data-testid="no404-link-card"
          >
            <div
              className="relative overflow-hidden rounded-[2rem] border border-[#CCFF00]/30 p-8 md:p-14"
              style={{
                background:
                  "linear-gradient(135deg, rgba(204,255,0,0.08) 0%, rgba(204,255,0,0.02) 60%, rgba(0,0,0,0) 100%), #0a0a0a",
              }}
            >
              {/* Big background lime word */}
              <div
                aria-hidden
                className="absolute -right-4 -bottom-4 md:-right-10 md:-bottom-10 font-display font-black uppercase tracking-tighter leading-none text-[25vw] md:text-[14rem] text-[#CCFF00]/10 select-none"
              >
                no404
              </div>

              <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-7">
                  <span className="eyebrow eyebrow-lime">Sister project</span>
                  <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-6xl lg:text-7xl mt-5">
                    no one should be <br />
                    <span className="text-[#CCFF00] glow-orange" style={{ textShadow: "0 0 32px rgba(204,255,0,0.45)" }}>
                      without a website.
                    </span>
                  </h2>
                  <p className="mt-6 max-w-xl text-white/75 text-lg">
                    Inkaa builds for ambitious brands. <span className="font-semibold text-white">no404.fun</span> builds for everyone else —
                    students, side-hustlers and small businesses getting their
                    first real site, on a budget that actually fits.
                  </p>

                  <div className="mt-8 flex flex-wrap items-center gap-3">
                    <span className="btn-primary btn-lime">
                      Visit no404.fun <ArrowUpRight className="h-4 w-4" />
                    </span>
                    <span className="float-tag border-[#CCFF00]/30 text-[#CCFF00]">
                      <Heart className="h-3 w-3" /> Built with love
                    </span>
                  </div>
                </div>

                <div className="lg:col-span-5">
                  <div className="grid grid-cols-2 gap-4">
                    {[
                      { k: "From", v: "$0", sub: "with starter pack" },
                      { k: "Launch in", v: "72 h", sub: "guaranteed" },
                      { k: "For", v: "everyone", sub: "students • SMBs" },
                      { k: "Vibe", v: "fun.", sub: "no404, no nonsense" },
                    ].map((t) => (
                      <div
                        key={t.k}
                        className="rounded-2xl border border-white/10 bg-black/40 p-5"
                      >
                        <div className="text-[10px] uppercase tracking-[0.24em] text-white/50">
                          {t.k}
                        </div>
                        <div className="font-display text-lg sm:text-2xl lg:text-3xl font-bold text-[#CCFF00] mt-1 break-words">
                          {t.v}
                        </div>
                        <div className="text-xs text-white/55 mt-1">{t.sub}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
